import { api } from './../../api.js';
import { config } from './../../config.js';

const state = {
    config : null
}

const getters = {
    getConfig : state => {
        return state.config;
    }
}

const mutations = {
    setConfig : (state, config) => {
        state.config = config.data;
    }
}

const actions = {
    CONFIG : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('config'), data).then(res => {
                localStorage.setItem('hash_teatro', res.data.hash_teatro)
                commit('setConfig', res);
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SELECT_CLUBES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('select.clubes'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SELECT_PROVINCIAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('select.provincias'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SELECT_LOCATIONS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('select.locations'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SELECT_DIVISIONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('select.divisiones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SELECT_GENEROS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('select.generos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SOLICITAR_DEVOLUCION : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('solicitar.devolucion'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }
}

export default {
    state,
    actions,
    getters,
    mutations
};
